export const UserRole = {
  MigrationAdmin: 'MigrationAdmin',
  MigrationOperator: 'MigrationOperator',
  MigrationViewer: 'MigrationViewer',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
}

export interface UserClaims {
  sub: string;
  email: string;
  name: string;
  roles: UserRole[];
}

export const ROLE_PERMISSIONS = {
  [UserRole.MigrationAdmin]: ['read', 'write', 'delete', 'admin'] as const,
  [UserRole.MigrationOperator]: ['read', 'write'] as const,
  [UserRole.MigrationViewer]: ['read'] as const,
} as const;

export type Permission = 'read' | 'write' | 'delete' | 'admin';

export function hasPermission(role: UserRole, permission: Permission): boolean {
  const permissions = ROLE_PERMISSIONS[role];
  return (permissions as readonly string[]).includes(permission);
}

export function canStartMigration(role: UserRole): boolean {
  return hasPermission(role, 'write');
}

export function canRetryMigration(role: UserRole): boolean {
  return hasPermission(role, 'write');
}

export function canViewSettings(role: UserRole): boolean {
  return hasPermission(role, 'admin');
}

export function canEditSettings(role: UserRole): boolean {
  return hasPermission(role, 'admin');
}
